<div class="row">
    <!-- <div class="col-2"></div> -->
    <div>
        <nb-card class="custom-card">
            <nb-card-body class="custom-body">
                <div class="mb-2" style="margin-left: -10px;">
                    <!-- <h5 class="title">{{title}}</h5> -->
                    <img src="../../../assets/images/hit2open Inverted Color (1).png" width="205px">
                </div>
                <div id="qrcode">
                    <qrcode [qrdata]="inputData" [width]="250" [errorCorrectionLevel]="'M'"></qrcode>
                </div>
                <div class="text-center mt-2 mb-2">
                    <small class="text-muted">{{inputData}}</small>
                </div>
                <div class="text-center mt-1">
                    <button type="button" class="btn btn-primary" (click)="onDownload()">Download</button>
                </div>

            </nb-card-body>
        </nb-card>
    </div>
    <!-- <div class="col-2"></div> -->
</div>